// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Kq-z","breadcrumbForward":"Lq-z","breadcrumbBack":"Mq-z","selected":"Nq-z"};